export enum SortByOption {
    modifiedDate = 'modifiedDate',
    status = 'status',
    doc = 'doc'
}
